import React from 'react';
import PropTypes from 'prop-types';
//import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as dialogPopupActions from '../../actions/dialogPopupActions';
import * as keyboardConstants from '../../constants/keyboardConstants';
import * as objectConstants from '../../constants/objectConstants';
import * as appHelper from "../../helpers/appHelper";

//import toastr from 'toastr';

export class DialogPopup extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            currentOpacity: 0,
            currentTop: 0,

            isOpenOpacity: 1,
            isOpenTop: 0,

            isClosedOpacity: 0,
            isClosedTop: 0,

            dialogPopup: Object.assign({}, this.props.dialogPopup)

        };
        this.openDialog = this.openDialog.bind(this);
        this.isOpenFunc = this.isOpenFunc.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.isClosedFunc = this.isClosedFunc.bind(this);
        this.setAccessibleExit = this.setAccessibleExit.bind(this);

        this.dialogPage = React.createRef();
    }

    componentDidMount() {
        window.addEventListener("keydown", this.setAccessibleExit);

        let func =  this.openDialog;
        setTimeout(function(){

            func();
        },200);

    }

    componentWillReceiveProps(nextProps) {
        if (this.state.dialogPopup !== nextProps.dialogPopup) {

            //console.log(`nextProps.dialogPopup`,nextProps.dialogPopup);
            this.setState({dialogPopup: Object.assign({}, nextProps.dialogPopup,{
                isOpen: this.state.dialogPopup.isOpen,
                currentClassState: this.state.dialogPopup.currentClassState
            })});
        }
    }

    componentWillUnmount(){
        window.removeEventListener("keydown", this.setAccessibleExit);
    }

    openDialog() {
        let ref = this.dialogPage.current;
        if(appHelper.isEleDefined(ref)) {

            TweenLite.to(ref, objectConstants.DIALOG_DURATION, {
                opacity: this.state.isOpenOpacity,
                top: this.state.isOpenTop,
                delay: 0,
                ease: Expo.easeIn//ease: Expo.easeInOut
            }).eventCallback("onComplete", this.isOpenFunc);
        }
    }
        //TweenLite.to(ref, 0.2, {opacity: this.state.isOpenOpacity, top: this.state.isOpenTop}).eventCallback("onComplete", this.isOpenFunc);//.eventCallback("onComplete", this.isOpenFunc);
    //}

    isOpenFunc(){
        this.setState(
            {dialogPopup: Object.assign({}, this.state.dialogPopup,{
                isOpen: true,
                currentClassState: this.state.dialogPopup.classStates.isOpen
            })}
        );
    }

    closeDialog() {
        let dialogSource = document.getElementById(this.state.dialogPopup.config.sourceId);
        if(appHelper.isDefined(dialogSource) && dialogSource !== null){
            dialogSource.focus();
        }
        this.setState(
            {
                dialogPopup: Object.assign({}, this.state.dialogPopup, {
                    isOpen: false,
                    currentClassState: this.state.dialogPopup.classStates.isClosed
                })
            }
        );
        if(appHelper.isDefined(this) && this !== null) {

            TweenLite.to(this, objectConstants.DIALOG_DURATION, {
                state: {
                    currentOpacity: this.state.isClosedOpacity,
                    currentTop: this.state.isClosedTop
                }, delay: 0.5
            }).eventCallback("onComplete", this.isClosedFunc);
        }
    }

    isClosedFunc(){
        this.props.actions.removeDialog();

    }

    setAccessibleExit(event){
        if(event.which === keyboardConstants.ESCAPE_KEY){
            event.preventDefault();
            this.closeDialog();
        }
    }

    render() {
        let DialogComponent = this.state.dialogPopup.config.dialogComponent;
        return (
            <div ref={this.dialogPage} className={"dialog-page " + this.state.dialogPopup.currentClassState} style={{opacity: this.state.currentOpacity }} role="dialog" >
                <DialogComponent dialogPopup={this.state.dialogPopup} onCloseDialog={this.closeDialog} style={{opacity: this.state.currentOpacity, top: this.state.currentTop }}/>
            </div>
        );

    }
}

DialogPopup.propTypes = {
    dialogPopup: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

//Pull in the React Router context so router is available on this.context.router.
DialogPopup.contextTypes = {
    router: PropTypes.object
};

//Init
function mapStateToProps(state, ownProps) {
    return {
        dialogPopup: state.dialogPopup
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DialogPopup);



/** WEBPACK FOOTER **
 ** ./src/components/dialogs/DialogPopup.js
 **/